export default class BidNumber {
  static isValid(bidNumber: string = ''): boolean {
    const regex = /^ID-\d{4}-\d{4}$/
    return regex.test(bidNumber)
  }
}
